import React, { useState } from "react";
import { Box, Button, Container, Paper, Skeleton, Typography } from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useTranslation } from "react-i18next";

const LOCATIONS = [
  {
    name: "Why Not Car Rental Santa Cruz",
    subtitle: "locationsAirport",
    address: "R. do Cano 9, 9100-109 Santa Cruz",
    lat: 32.6938692,
    lng: -16.782692,
    mapsUrl:
      "https://www.google.com/maps/place/Why+Not+Car+Rental+Santa+Cruz/@32.6938692,-16.782692,17z",
  },
  {
    name: "Why Not Car Rental Funchal",
    subtitle: "locationsFunchal",
    address: "R. Ivens 12, 9000-046 Funchal",
    lat: 32.6482654,
    lng: -16.9118057,
    mapsUrl:
      "https://www.google.com/maps/place/Why+Not+Car+Rental+Funchal/@32.6482654,-16.9118057,17z",
  },
];

const MapCard = ({ loc }) => {
  const { t } = useTranslation();
  const [loaded, setLoaded] = useState(false);

  return (
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        borderRadius: 3,
        border: "1px solid #e8eaf0",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Mini map */}
      <Box sx={{ height: 240, flexShrink: 0, position: "relative" }}>
        {!loaded && (
          <Skeleton
            variant="rectangular"
            width="100%"
            height={240}
            sx={{ position: "absolute", top: 0, left: 0, zIndex: 1 }}
          />
        )}
        <iframe
          title={loc.name}
          width="100%"
          height="100%"
          style={{ border: 0, display: "block" }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://maps.google.com/maps?q=${loc.lat},${loc.lng}&z=17&output=embed`}
          onLoad={() => setLoaded(true)}
        />
      </Box>

      {/* Info */}
      <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: 1.5, flexGrow: 1 }}>
        <Typography variant="h6" fontWeight={700} color="#1C2541">
          {loc.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t(loc.subtitle)}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.5 }}>
          <PlaceIcon sx={{ color: "#EE8013", fontSize: 20, mt: "2px", flexShrink: 0 }} />
          <Typography variant="body2" color="text.secondary">
            {loc.address}
          </Typography>
        </Box>
        <Box sx={{ mt: "auto", pt: 1 }}>
          <Button
            variant="outlined"
            size="small"
            endIcon={<OpenInNewIcon />}
            href={loc.mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              borderColor: "#1C2541",
              color: "#1C2541",
              fontWeight: 600,
              "&:hover": { backgroundColor: "#1C2541", color: "white" },
            }}
          >
            {t("openInMaps")}
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

const Locations = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ py: { xs: 5, md: 8 } }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 5 }}>
          <Typography variant="h4" fontWeight={700} color="#1C2541" gutterBottom>
            {t("ourLocations")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t("ourLocationsSubtitle")}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 4,
          }}
        >
          {LOCATIONS.map((loc) => (
            <MapCard key={loc.name} loc={loc} />
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Locations;
